import styled from '@emotion/styled'

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const WarningIconContainer = styled.div`
  margin-bottom: 20px;
`
export const TextContainer = styled.div`
  text-align: center;
`
export const VerificationErrorText = styled.p`
  margin-bottom: 24px;
` 